<template>
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="text-center">
      <p 
        v-if="cycle.count_themes > 0"
        class="text-sm-subtitle-2 font-weight-bold mb-1"
      >
        Escolha seus <b>módulos de desempenho</b> para o {{ cycle.cycle_name }}.
      </p>
      <p
        v-else
        class="text-sm-subtitle-2 font-weight-bold mb-1"
      >
        Atenção! É necessário escolher seus módulos para o {{ cycle.cycle_name }}.
      </p>
      <v-btn
        color="nitro"
        class="my-2 my-sm-0 white--text"
        @click="onClick"
      >
        Escolher módulos
      </v-btn>
    </div>
  </div>
</template>
<script>

import { selectModulesRouteName } from '@/student/constants/routes';
import { mapMutations } from "vuex";

export default {
  props: {
    cycle: {
      type: Object,
      required: true
    },
  },
  computed: {
    allModulesDefined(){
        return this.modules.length >= this.cycle.module_quantity
    }
  },
  methods: {
    ...mapMutations(['SET_CYCLE']),
    onClick() {
        if (!this.selectedCycle) {
            this.SET_CYCLE(this.cycle);
        }
        if (this.$route.name !== selectModulesRouteName) {
            this.$router.push({ name: selectModulesRouteName })
        }
    }
  }
}
</script>